import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-message-square",
  "use": "icon-message-square-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-message-square\"><path d=\"M832 810.667H192c-35.2 0-64-28.8-64-64v-448c0-35.2 28.8-64 64-64h640c35.2 0 64 28.8 64 64v448c0 35.2-28.8 64-64 64zM192 277.333c-11.733 0-21.333 9.6-21.333 21.334v448c0 11.733 9.6 21.333 21.333 21.333h640c11.733 0 21.333-9.6 21.333-21.333v-448c0-11.734-9.6-21.334-21.333-21.334H192z\" /><path d=\"M512 576a21.12 21.12 0 0 1-11.733-3.627l-256-170.666a21.547 21.547 0 0 1-5.974-29.654c6.4-9.813 19.84-12.373 29.654-5.973L512 529.067l244.267-162.774a21.355 21.355 0 1 1 23.68 35.627l-256 170.667C520.32 574.72 516.053 576 512 576z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/message-square.svg
// module id = oyUQ
// module chunks = 65